import { getDomainArtifacts } from "src/redux/reducers/appSlice";
import { resetSocketState } from "src/redux/reducers/socketSlice";
import { logoutAction, userLogout } from "src/redux/reducers/user";
import { useAppDispatch, useAppSelector } from "src/redux/redux-hooks";
import { socket } from "src/sockets/socketService";
import userSocket from "src/sockets/userSocket";

const useLogout = () => {
  const dispatch = useAppDispatch();
  const { userSocketConnected } = useAppSelector(({ socket }) => socket);

  const handle = () => {
    dispatch(resetSocketState());

    if (userSocketConnected) {
      userSocket.disconnect();
      socket.disconnect();
    }
    sessionStorage.clear();
    localStorage.clear();
    dispatch(logoutAction());
    dispatch(getDomainArtifacts());
  };

  const handleLogout = (apiCall: boolean = true) => {
    return new Promise((resolve, reject) => {
      if (apiCall) {
        dispatch(userLogout())
          .unwrap()
          .then(() => {
            handle();
            resolve(true);
          })
          .catch((err) => {
            handle();
            reject(err);
          });
      } else {
        handle();
        resolve(true);
      }
    });
  };

  return { handleLogout };
};

export default useLogout;
